import React from "react";
import { LayoutPC } from "./Components/LayoutPC";

import LayoutMobile from "./Components/LayoutMobile";
import { useDeviceType } from "./polyfills";
import WebIMProvider from "./Components/WebIMProvider";

interface FullIMProps {
    onGotoDetail?(sessionId: string): void;
}

export function FullIM({ onGotoDetail }: FullIMProps) {
    const { isPC } = useDeviceType();

    return (
        <WebIMProvider>
            {isPC && <LayoutPC />}

            {!isPC && onGotoDetail && (
                <LayoutMobile onGotoDetail={onGotoDetail} />
            )}
        </WebIMProvider>
    );
}
